import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import { UserRole } from '@/types/UserRole';
import routes from '@/router/routes';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'is-active',
  routes,
  scrollBehavior() {
      return {x: 0, y: 0};
  }
});

router.beforeEach((to, from, next) => {
  const isAdmin = to.matched.some((record) => record.meta.admin);
  const onlyAdmin = isAdmin && store.getters.getUserRole !== UserRole.Admin;
  const onlyLoggedIn = to.matched.some((record) => record.meta.loggedIn) && !store.getters.isSignedIn;

  if (onlyAdmin || onlyLoggedIn) {
    const hasLanguage = to.params && to.params.language && allowedLanguages.includes(to.params.language.toLowerCase());
    next(`/${hasLanguage ? to.params.language.toLowerCase() : 'sv'}`);
  } else {
    next();
  }
});

const allowedLanguages = ['sv', 'fi', 'en', 'no'];

router.beforeEach((to, from, next) => {
  // Evaluate whether or not the URL contains a language
  const hadLanguage = from.params && from.params.language && allowedLanguages.includes(from.params.language);
  const hasLanguage = to.params && to.params.language && allowedLanguages.includes(to.params.language);

  // If the language hasn't changed since last route we're done
  if (hasLanguage && hadLanguage && from.params.language.toLowerCase() === to.params.language.toLowerCase()) {
    return next();
  }

  // Set the default language
  let language = 'sv';

  if (hadLanguage) {
    language = from.params.language.toLowerCase();
  }

  // Overwrite the language with the route if there is one
  if (hasLanguage) {
    language = to.params.language.toLowerCase();
  }

  // Make sure the language is valid
  if (!allowedLanguages.includes(language)) {
    language = 'sv';
  }

  // Set the website language based on the URL
  store.state.language = language;

  // Redirect to a url with the language
  if (!hasLanguage) {
    return next(`/${language}${to.fullPath}`);
  }
  return next();
});

export default router;
